// @TODO [salva@26-11-2024] [VA2-XXX] replace /api import with fetchCreator.
import { client } from "./fetchCreator";

export default client;
